import styles from './ccf-agent-dashboard-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Props for the CcfAgentDashboardIcon component.
 */
export interface CcfAgentDashboardIconProps {}

/**
 * A dashboard icon component for the CCF Agent.
 * 
 * @param props - The props for the CcfAgentDashboardIcon component.
 * @returns A JSX element representing the dashboard icon.
 */
export function CcfAgentDashboardIcon(props: CcfAgentDashboardIconProps) {
  return (
    // <SvgIcon {...props} width="32" height="34" viewBox="0 0 32 34" sx={{ fontSize: 32 }}>
      <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-8tu19t" focusable="false" width="32" height="34" aria-hidden="true" viewBox="0 0 32 34" data-testid="cxa-logo">
      <path d="M29.333 36V28H21.333L29.333 36Z" fill="#FF9400"></path>
      <path
        d="M30 16H10C8.89543 16 8 16.8954 8 18V30C8 31.1046 8.89543 32 10 32H30C31.1046 32 32 31.1046 32 30V18C32 16.8954 31.1046 16 30 16Z"
        fill="#FF9400"
      ></path>
      <path
        d="M30 14.667H10C8.89543 14.667 8 15.5624 8 16.667V28.667C8 29.7716 8.89543 30.667 10 30.667H30C31.1046 30.667 32 29.7716 32 28.667V16.667C32 15.5624 31.1046 14.667 30 14.667Z"
        fill="#F66F5B"
      ></path>
      <path
        opacity="0.15"
        d="M32 28V22.509L24.157 14.667H10.667C10.3167 14.6669 9.96986 14.7358 9.64623 14.8698C9.32259 15.0037 9.02853 15.2002 8.78085 15.4478C8.53317 15.6955 8.33673 15.9896 8.20275 16.3132C8.06876 16.6369 7.99987 16.9837 8 17.334V28.001C8 28.3512 8.06899 28.6979 8.20303 29.0215C8.33708 29.345 8.53354 29.6389 8.78121 29.8865C9.02887 30.1341 9.32289 30.3304 9.64646 30.4644C9.97003 30.5983 10.3168 30.6671 10.667 30.667H29.333C29.6833 30.6671 30.0301 30.5982 30.3538 30.4642C30.6774 30.3303 30.9715 30.1338 31.2191 29.8861C31.4668 29.6385 31.6633 29.3444 31.7973 29.0208C31.9312 28.6971 32.0001 28.3503 32 28Z"
        fill="url(#paint0_linear_7408_10524)"
      ></path>
      <path
        d="M2.66699 21.333V13.333H10.667L2.66699 21.333Z"
        fill="#C3C5C9"
      ></path>
      <path
        d="M22 1.33301H2C0.89543 1.33301 0 2.22844 0 3.33301V15.333C0 16.4376 0.89543 17.333 2 17.333H22C23.1046 17.333 24 16.4376 24 15.333V3.33301C24 2.22844 23.1046 1.33301 22 1.33301Z"
        fill="#C3C5C9"
      ></path>
      <path
        d="M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z"
        fill="#EBEBEB"
      ></path>
      <path
        opacity="0.1"
        d="M14.7479 21.252L11.9199 24.08L18.5059 30.666H24.1629L14.7479 21.252Z"
        fill="url(#paint1_linear_7408_10524)"
      ></path>
      <path
        opacity="0.1"
        d="M21.414 21.252L18.585 24.081L25.172 30.666H29.333C29.751 30.6621 30.1623 30.5593 30.533 30.366L21.414 21.252Z"
        fill="url(#paint2_linear_7408_10524)"
      ></path>
      <path
        opacity="0.1"
        d="M28.081 21.252L25.252 24.081L31.131 29.9579C31.4042 29.7099 31.6226 29.4075 31.7722 29.0702C31.9219 28.7329 31.9994 28.368 32 27.999V25.171L28.081 21.252Z"
        fill="url(#paint3_linear_7408_10524)"
      ></path>
      <path
        d="M13.333 24.667C14.4376 24.667 15.333 23.7716 15.333 22.667C15.333 21.5624 14.4376 20.667 13.333 20.667C12.2284 20.667 11.333 21.5624 11.333 22.667C11.333 23.7716 12.2284 24.667 13.333 24.667Z"
        fill="white"
      ></path>
      <path
        d="M26.667 24.667C27.7716 24.667 28.667 23.7716 28.667 22.667C28.667 21.5624 27.7716 20.667 26.667 20.667C25.5624 20.667 24.667 21.5624 24.667 22.667C24.667 23.7716 25.5624 24.667 26.667 24.667Z"
        fill="white"
      ></path>
      <path
        d="M20 24.667C21.1046 24.667 22 23.7716 22 22.667C22 21.5624 21.1046 20.667 20 20.667C18.8954 20.667 18 21.5624 18 22.667C18 23.7716 18.8954 24.667 20 24.667Z"
        fill="white"
      ></path>
      <path
        opacity="0.1"
        d="M24.2409 15.998H15.7579L8.87891 9.11899L10.9339 2.66699L24.2409 15.998Z"
        fill="url(#paint4_linear_7408_10524)"
      ></path>
      <path
        d="M14.1361 8.20595L13.0721 10.048C11.7779 9.29773 10.7023 8.22214 9.9521 6.92793L11.7951 5.86394L10.9341 2.66396H7.3641C7.27316 2.66333 7.18303 2.6812 7.0992 2.71648C7.01537 2.75176 6.93959 2.80369 6.87646 2.86916C6.81333 2.93463 6.76417 3.01225 6.73196 3.09731C6.69975 3.18236 6.68517 3.27307 6.6891 3.36394C6.86158 5.94477 7.96473 8.37534 9.79372 10.2043C11.6227 12.0333 14.0533 13.1365 16.6341 13.3089C16.725 13.3129 16.8157 13.2983 16.9007 13.2661C16.9858 13.2339 17.0634 13.1847 17.1289 13.1216C17.1944 13.0585 17.2463 12.9827 17.2816 12.8989C17.3169 12.815 17.3347 12.7249 17.3341 12.634V9.06694L14.1361 8.20595Z"
        fill="#333333"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_7408_10524"
          x1="20"
          y1="14.491"
          x2="20"
          y2="29.483"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="1" stop-opacity="0.251"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_7408_10524"
          x1="13.3034"
          y1="22.6358"
          x2="19.8504"
          y2="33.7035"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="1" stop-opacity="0.251"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_7408_10524"
          x1="20.1501"
          y1="22.8241"
          x2="26.6173"
          y2="33.2245"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="1" stop-opacity="0.251"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_7408_10524"
          x1="26.7095"
          y1="22.7059"
          x2="33.2443"
          y2="26.6386"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="1" stop-opacity="0.251"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_7408_10524"
          x1="9.03253"
          y1="5.02658"
          x2="19.5799"
          y2="19.0301"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="1" stop-opacity="0.251"></stop>
        </linearGradient>
      </defs>
      </svg>
    // </SvgIcon>
  );
}

export default CcfAgentDashboardIcon;
